import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import { kkTranslations, ruTranslations } from './locales'

const storedLang = sessionStorage.getItem('django_language')

if (!storedLang) sessionStorage.setItem('django_language', 'ru')

export const resources = {
  kk: kkTranslations,
  ru: ruTranslations
} as const

export const defaultNS = 'main'

i18n.use(initReactI18next).init({
  fallbackLng: sessionStorage.getItem('django_language') ?? 'ru',
  lng: sessionStorage.getItem('django_language') ?? 'ru',
  resources,
  ns: ['landing'],
  defaultNS,
  interpolation: {
    escapeValue: false
  }
})

i18n.languages = ['kk', 'ru']

export default i18n
